// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-search {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.custom-search-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.custom-search-icon {
  position: absolute;
  left: 10px;
  font-size: 18px;
  color: var(--text-muted);
  pointer-events: none;
}

.custom-search-input {
  width: 100%;
  padding: 10px 12px 10px 36px;
  background-color: var(--surface-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Inter', sans-serif;
  color: var(--text-primary);
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.custom-search-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 2px rgba(242, 92, 36, 0.1);
}

.custom-search-input:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-search-hint {
  font-size: 12px;
  color: var(--text-muted);
  padding: 0 4px;
}

.custom-search-results {
  list-style: none;
  margin: 0;
  padding: 4px;
  background-color: var(--surface-light);
  border: 1px solid var(--border-light);
  border-radius: 8px;
  max-height: 220px;
  overflow-y: auto;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.custom-search-status {
  padding: 10px 12px;
  font-size: 13px;
  color: var(--text-secondary);
  text-align: center;
}

.custom-search-status--error {
  color: var(--error-text);
}

.custom-search-result {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  color: var(--text-primary);
  transition: background-color 0.15s;
}

.custom-search-result:hover:not(:disabled),
.custom-search-result:focus-visible {
  background-color: var(--background-light);
  outline: none;
}

.custom-search-result:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.custom-search-result-name {
  font-weight: 500;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.custom-search-result-number {
  font-size: 12px;
  color: var(--text-secondary);
  font-variant-numeric: tabular-nums;
  flex-shrink: 0;
}
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/ClientSelector/ClientSelector.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,gCAAgC;EAChC,0BAA0B;EAC1B,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,sCAAsC;EACtC,qCAAqC;EACrC,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;;EAEE,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,OAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kCAAkC;EAClC,cAAc;AAChB","sourcesContent":[".custom-search {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.custom-search-input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.custom-search-icon {\n  position: absolute;\n  left: 10px;\n  font-size: 18px;\n  color: var(--text-muted);\n  pointer-events: none;\n}\n\n.custom-search-input {\n  width: 100%;\n  padding: 10px 12px 10px 36px;\n  background-color: var(--surface-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  font-size: 14px;\n  font-family: 'Inter', sans-serif;\n  color: var(--text-primary);\n  transition: all 0.2s;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.custom-search-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 2px rgba(242, 92, 36, 0.1);\n}\n\n.custom-search-input:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.custom-search-hint {\n  font-size: 12px;\n  color: var(--text-muted);\n  padding: 0 4px;\n}\n\n.custom-search-results {\n  list-style: none;\n  margin: 0;\n  padding: 4px;\n  background-color: var(--surface-light);\n  border: 1px solid var(--border-light);\n  border-radius: 8px;\n  max-height: 220px;\n  overflow-y: auto;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n\n.custom-search-status {\n  padding: 10px 12px;\n  font-size: 13px;\n  color: var(--text-secondary);\n  text-align: center;\n}\n\n.custom-search-status--error {\n  color: var(--error-text);\n}\n\n.custom-search-result {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  font-family: 'Inter', sans-serif;\n  font-size: 14px;\n  color: var(--text-primary);\n  transition: background-color 0.15s;\n}\n\n.custom-search-result:hover:not(:disabled),\n.custom-search-result:focus-visible {\n  background-color: var(--background-light);\n  outline: none;\n}\n\n.custom-search-result:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.custom-search-result-name {\n  font-weight: 500;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.custom-search-result-number {\n  font-size: 12px;\n  color: var(--text-secondary);\n  font-variant-numeric: tabular-nums;\n  flex-shrink: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
